import styled from 'styled-components';

import { BaseStyle } from '@nhl/nhl-breakaway-ui';

// NOTE Reconsider how to make this guy fit in the grid. The grid-area implies it belongs in a 2col grid.
const Container = styled.div`
    display: flex;
    flex-direction: column;
    grid-column-start: span 2;

    > * {
        margin-bottom: 10px;
    }
`;

const UserMadeFilter = styled.div`
    background: #eee;
    display: grid;
    grid-template-columns: 4fr 2fr 2fr 1fr;
    height: 49px;
    align-items: center;
    justify-items: center;

    > * {
        justify-self: start;
        padding-left: 10px;
    }

    ${BaseStyle.Mixins.screenSizes.large} {
        > * {
            justify-self: inherit;
            padding-left: inherit;
        }
    }
`;

const CloseButton = styled.div`
    ${BaseStyle.Mixins.fontStyles.ui['24m']};
    cursor: pointer;
`;

export { Container, UserMadeFilter, CloseButton };
